"use strict";

require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const WorkflowDesigner = _ref => {
  let {
    workflow: {
      frameEl,
      workflowId,
      apiPath,
      sendAccessToken,
      token,
      targetOrigin
    },
    style,
    className,
    width,
    height,
    onSave,
    onDeploy,
    onDeploying,
    onChanged,
    colorPrimary,
    fontSize,
    disableMessages,
    disableActions
  } = _ref;
  const onLoad = (0, _react.useCallback)(() => {
    sendAccessToken(token);
  }, [sendAccessToken, token]);
  (0, _react.useEffect)(() => {
    const callback = e => {
      try {
        const decodedMsg = JSON.parse(e.data);
        if (decodedMsg.message) {
          if (decodedMsg.message === 'statusChange') {
            if (decodedMsg.payload.status === 'saved') {
              onSave();
            } else if (decodedMsg.payload.status === 'deployed') {
              onDeploy();
            } else if (decodedMsg.payload.status === 'deploying') {
              onDeploying();
            } else if (decodedMsg.payload.status === 'changed') {
              onChanged();
            } else {
              console.info('Unsupported status', decodedMsg.payload.status);
            }
          }
        }
      } catch (err) {
        console.info('Skipping a message with this data', e.data);
      }
    };
    window.addEventListener('message', callback);
    return () => {
      window.removeEventListener('message', callback);
    };
  }, [onSave, onDeploy, onDeploying, onChanged]);
  if (!apiPath) return null;
  const path = "".concat(apiPath.origin === '' ? '' : "https://".concat(apiPath.origin), "/embedded/workflows/").concat(workflowId, "/edit?&colorPrimary=").concat(encodeURIComponent(colorPrimary), "&fontSize=").concat(fontSize, "&disableMessages=").concat(disableMessages, "&disableActions=").concat(disableActions);
  return /*#__PURE__*/_react.default.createElement("iframe", {
    src: path,
    onLoad: onLoad,
    width: width,
    height: height,
    frameBorder: "0",
    style: style,
    className: className,
    ref: frameEl,
    title: "Workflow ".concat(workflowId)
  });
};
WorkflowDesigner.defaultProps = {
  onSave: () => {},
  onDeploy: () => {},
  onDeploying: () => {},
  onChanged: () => {},
  width: '100%',
  height: '500px',
  colorPrimary: '#568CDC',
  fontSize: 14,
  disableMessages: false,
  disableActions: false
};
var _default = WorkflowDesigner;
exports.default = _default;